import type { HeroProps } from '@/components/lemonadeGoesGlobal/Hero';
import { sharedConfig } from '@/pageConfig/shared';
import og from '@/static/assets/lemonade_goes_global/nl/og.png';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/LemonadeGoesGlobal/lemonadeGoesGlobal__nl-NL.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export interface Config extends BasePageConfig {
  hero: HeroProps;
}

export const config: Config = {
  layout: { ...sharedConfig['nl-NL'].layout, showAskUsAnything: true },
  seo: {
    title: 'Waar in de VS en Europa zijn de Verzekeringen van Lemonade Beschikbaar? | Lemonade',
    metaTitle: 'Waar in de VS en Europa zijn de Verzekeringen van Lemonade Beschikbaar? | Lemonade',
    description:
      'Lemonade brengt huiseigenaren- en inboedelverzekeringen naar de VS en Europa✨ gestuurd door technologie en gedreven door sociaal maatschappelijk belang. Kijk hier om te zien waar Lemonade beschikbaar is, of laat je e-mailadres achter en dan houden we je op de hoogte als we jouw kant op komen! GoLemonade',
    ogImage: og.src,
  },
  hero: {
    title: 'Wees als eerste op de hoogte!',
    subtitle: `We breiden uit in de <a href="https://www.lemonade.com/blog/lemonade-expansion-united-states/">VS</a> en Europa. Zijn we nog niet beschikbaar in jouw land?\nLaat je e-mailadres achter en dan houden we je op de hoogte.`,
  },
  MDXContent: content as DocumentTypes,
};
